const satisfactionSurvey = {
    "sections": [
        {
            "subject": "整體評價",
            "description": "請說明您對於課程的整體評價，及需要我們改善的項目",
            "questions": [
                {
                    "description": "整體評價",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "建議改善事項",
                    "type": "oeq",
                }
            ]
        },
        {
            "subject": "課程講師",
            "description": "請問您對於課程講師的滿意情形，及對講師的建議事項",
            "questions": [
                {
                    "description": "王小華",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "林小花",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                }
            ]
        },
        {
            "subject": "行政服務",
            "description": "請問您對於行政服務的滿意情形，及建議事項",
            "questions": [
                {
                    "description": "行政服務-教學環境",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "行政服務-餐飲安排",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "行政服務-服務人員",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "行政服務-教材品質",
                    "type": "scq",
                    "options": ["非常滿意", "滿意", "尚可", "不滿意", "非常不滿意"],
                },
                {
                    "description": "對訓練單位的建議",
                    "type": "oeq",
                }
            ]
        },
        {
            "subject": "其他",
            "questions": [
                {
                    "description": "如有其他任何意見，歡迎告訴我們",
                    "type": "oeq",
                    "required": false
                }
            ]

        }
    ]
};

export default satisfactionSurvey;